import { render, staticRenderFns } from "./QuesSlider.vue?vue&type=template&id=e267e266&scoped=true&"
import script from "./QuesSlider.vue?vue&type=script&lang=js&"
export * from "./QuesSlider.vue?vue&type=script&lang=js&"
import style0 from "./QuesSlider.vue?vue&type=style&index=0&id=e267e266&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e267e266",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCardText,VCol,VFileInput,VRow,VSlider,VTextField,VTextarea})
